import React from "react";
import { formattedDateTime } from "../../../utils/utilities";

const MatkaBetResultTableList = ({betResultList}) => {

  return (
    <div className="table-responsive">
      <div className="table-wrapper">
        <div className="table">
          <table className="table">
            <thead>
              <tr>
                <th>Market Id</th>
                <th>Market Name</th>
                <th>Result</th>
                <th>Date Time</th>
              </tr>
            </thead>
            <tbody>
              {betResultList?.length > 0 ? (
                betResultList.map((row) => (
                  <tr key={row.id || Math.random()}>
                    <td>{row.MarketId || "N/A"}</td>
                    <td>{row.MarketName || "Unknown"}</td>
                    <td>{row.Result || "N/A"}</td>
                    <td>{formattedDateTime(row.CreatedOn) || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default MatkaBetResultTableList;
